import {dashboardFeatureKey, dashboardReducer, DashboardState} from './dashboard/_store/dashboard.reducer';
import {combineReducers} from '@ngrx/store';
import {meetingsFeatureKey, meetingsReducers, MeetingsState} from '@communication/meetings/meetings-state';
import {eventsFeatureKey, eventsReducer, EventsState} from "@communication/events/_store/events.reducer";

export const communicationFeatureKey = 'communication';

export interface CommunicationState {
    [dashboardFeatureKey]: DashboardState,
    [eventsFeatureKey]: EventsState,
    [meetingsFeatureKey]: MeetingsState
}

export const communicationReducers = combineReducers({
    [dashboardFeatureKey]: dashboardReducer,
    [eventsFeatureKey]: eventsReducer,
    [meetingsFeatureKey]: meetingsReducers
});
